import type { NodeDimension } from 'types/node_types';

// Image, Mask, Text node dimensions
// To prevent unwanted renders, only fully update when a dimension has changed
export function nodeDimensionsReducer(state: NodeDimension, payload: NodeDimension) {
  if (
    state.x !== payload.x ||
    state.y !== payload.y ||
    state.w !== payload.w ||
    state.h !== payload.h
  ) {
    return payload;
  }
  return state;
}

export function maskImageLoadedReducer(
  state: Record<string, boolean>,
  payload: { src: string; loaded: boolean }
) {
  const { src, loaded } = payload;

  return {
    ...state,
    [src]: loaded,
  };
}
